import { insertEventLog } from "../service/API";

export function addLog(eventName, eventAction, files) {
  const { name, email, department } = JSON.parse(
    sessionStorage.getItem("authUserData")
  );

  const dataForm = {
    email: email,
    name: name,
    department: department,
    event_name: eventName,
    event_action: eventAction,
    file_boq: files ? files.boqFile : null,
    file_tor: files ? files.torFile : null,
    file_qt: files ? files.qtFile : null,
  };

  insertEventLog(dataForm).then((response) => {
    if (response && response.status === 201) {
    } else {
      response
        ? console.log(
            `API response error: [${response.status}] ${response.data.err}`
          )
        : console.log(`API response error: addLog`);
    }
  });
}
